'use strict';

import api from '../../utils/api';
import utilities from '../../utils/utilities';
import { moment } from '../../main';

// initial state
const state = {
    visible: false,
    selectedTab: 1,
    tabs: [
        { id: 1, name: 'TABS__1' },
        { id: 2, name: 'TABS__2' },
        { id: 3, name: 'TABS__3' }
    ],
    textValue: '',
    textareaValue: '',
    checkboxValue: false,
    dropdownValue: null,
    dropdownItems: [
        { id: 'AL', name: 'STATES__ALABAMA' },
        { id: 'AK', name: 'STATES__ALASKA' },
        { id: 'AZ', name: 'STATES__ARIZONA' },
        { id: 'AR', name: 'STATES__ARKANSAS' },
        { id: 'CA', name: 'STATES__CALIFORNIA' },
        { id: 'CO', name: 'STATES__COLORADO' },
        { id: 'CT', name: 'STATES__CONNECTICUT' },
        { id: 'DE', name: 'STATES__DELAWARE' }
    ],
    radioValue: '#C0C0C0',
    radioItems: [
        { id: '#C0C0C0', name: 'COLOR__SILVER' },
        { id: '#808080', name: 'COLOR__GRAY' },
        { id: '#000000', name: 'COLOR__BLACK' }
    ],
    segmentedValue: 'FIRST',
    segmentedItems: [
        { id: 'FIRST', name: 'ORDINAL__FIRST' },
        { id: 'SECOND', name: 'ORDINAL__SECOND' },
        { id: 'THIRD', name: 'ORDINAL__THIRD' }
    ],
    dateString: null,
    dateTimeString: null,
    savedState: null,
    errors: {}
};

// mutations
const mutations = {
    open(state, { data, timezone }) {
        state.selectedTab = 1;

        state.textValue = data.textValue;
        state.textareaValue = data.textareaValue;
        state.checkboxValue = data.checkboxValue;
        state.dropdownValue = data.dropdownValue;
        state.radioValue = data.radioValue;
        state.segmentedValue = data.segmentedValue;
        state.dateString = data.date ? moment.tz(data.date, timezone).format('L') : null;
        state.dateTimeString = data.dateTime ? moment.tz(data.dateTime, timezone).format('L LT') : null;

        state.visible = true;
    },
    close(state) {
        state.visible = false;
        state.errors = {};
    },
    //setters
    selectedTab(state, value) {
        state.selectedTab = value;
    },
    textValue(state, value) {
        state.textValue = value;
    },
    textareaValue(state, value) {
        state.textareaValue = value;
    },
    checkboxValue(state, value) {
        state.checkboxValue = value;
    },
    dropdownValue(state, value) {
        state.dropdownValue = value;
    },
    radioValue(state, value) {
        state.radioValue = value;
    },
    segmentedValue(state, value) {
        state.segmentedValue = value;
    },
    dateString(state, value) {
        state.dateString = value;
    },
    dateTimeString(state, value) {
        state.dateTimeString = value;
    },
    errors(state, errors) {
        state.errors = errors;
    }
};

// functions
const functions = {
    prettify(key, value) {
        return `<span class="FormModal__key">"${key}"</span>:&nbsp;<span class="FormModal__value">${value}</span>`;
    }
};

// getters
const getters = {
    getStateString(state) {
        return '{<br/>' +
            functions.prettify('selectedTab', state.selectedTab) +
            ',<br/>' +
            functions.prettify('textValue', '"' + state.textValue + '"') +
            ',<br/>' +
            functions.prettify('textareaValue', '"' + state.textareaValue + '"') +
            ',<br/>' +
            functions.prettify('checkboxValue', state.checkboxValue) +
            ',<br/>' +
            functions.prettify('dropdownValue', '"' + state.dropdownValue + '"') +
            ',<br/>' +
            functions.prettify('radioValue', '"' + state.radioValue + '"') +
            ',<br/>' +
            functions.prettify('segmentedValue', '"' + state.segmentedValue + '"') +
            ',<br/>' +
            functions.prettify('dateString', '"' + state.dateString + '"') +
            ',<br/>' +
            functions.prettify('dateTimeString', '"' + state.dateTimeString + '"') +
            '<br/>' +
            '}';
    }
};

// actions
const actions = {
    open(store) {
        api.get(`/api/form/`).then(function(response) {
                const data = response.body;
                store.commit('open',
                    {
                        data: data,
                        timezone: store.rootState.settings.account.timezone
                    });
            },
            function() {
            });
    },
    close(store) {
        store.commit('close');
    },
    save(store) {
        api.put(
            '/api/form/',
            {
                textValue: store.state.textValue,
                textareaValue: store.state.textareaValue,
                checkboxValue: store.state.checkboxValue,
                dropdownValue: store.state.dropdownValue,
                radioValue: store.state.radioValue,
                segmentedValue: store.state.segmentedValue,
                date: utilities.convertStringToDate(store, store.state.dateString, true, 'L'),
                dateTime: utilities.convertStringToDate(store, store.state.dateTimeString, true, 'L LT')
            },
            'form/errors').then(
                function () {
                    store.commit('close');
                    store.dispatch('settings/addMessage',
                        store.rootGetters['translation/translate']('FORM__FORM_SUCCESSFULLY_SAVED'),
                        { root: true });
                },
                function () { });
    },
    //Setters
    setSelectedTab(store, value) {
        store.commit('selectedTab', value);
    },
    setTextValue(store, value) {
        store.commit('textValue', value);
    },
    setTextareaValue(store, value) {
        store.commit('textareaValue', value);
    },
    setCheckboxValue(store, value) {
        store.commit('checkboxValue', value);
    },
    setDropdownValue(store, value) {
        store.commit('dropdownValue', value);
    },
    setRadioValue(store, value) {
        store.commit('radioValue', value);
    },
    setSegmentedValue(store, value) {
        store.commit('segmentedValue', value);
    },
    setDateString(store, payload) {
        store.commit('dateString', payload.dateString);
    },
    setDateTimeString(store, payload) {
        store.commit('dateTimeString', payload.dateString);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/form.js